import i18n from 'i18next';
import translations from './translations.json';
import { initReactI18next } from 'react-i18next';


i18n.use(initReactI18next).init({
  interpolation: { escapeValue: false },
  lng: 'en',
  resources: translations,
});

export default i18n;
